import { Type } from 'class-transformer'
import { UserNotification } from './user-notification.model'

export class UserNotifications {
  unreadCount!: number
  @Type(() => UserNotification) notifications!: UserNotification[]
}
